import { ContentProperty, CreativeTypes, TextStyle } from '@bynder-studio/render-core';
import { gatewayClient, createService } from './connectors/httpClient';

type Preset = {
    elements: any[];
    textStyles: TextStyle[];
    contentProperties: ContentProperty[];
    customerId: number;
    name: string;
    type: CreativeTypes;
};

const httpClient = gatewayClient('/template-preset');

const presetsService = createService(httpClient, (client) => ({
    getPresets({
        customerId,
        size,
        page,
        search,
        sort,
        creativeType,
    }: {
        customerId: number;
        size: number;
        page: number;
        search: string;
        sort: [string, string];
        creativeType: CreativeTypes;
    }) {
        const query =
            `?customerId=${customerId}&` +
            `size=${size}&` +
            `sortingField=${sort[0].toUpperCase()}&` +
            `sortingOrder=${sort[1]}&` +
            `page=${page}${search ? '&query=' + search : ''}` +
            `&type=${creativeType}`;

        return client.get(query);
    },

    getPresetById(id: string) {
        return client.get(`/${id}`);
    },

    addPreset(preset: Preset) {
        return client.put('', preset);
    },

    deletePreset(id: string) {
        return client.delete(`/${id}`);
    },

    updatePreset(id: string, presetData: { name: string }) {
        return client.put(`/${id}`, presetData);
    },
}));

export default presetsService;
